import { Logo } from "./Logo";
import { COMPANY as C } from "../constants/company";

export const Footer = () => (
  <footer className="bg-ink text-cream/80 py-12">
    <div className="mx-auto max-w-7xl px-5 sm:px-8 flex flex-col sm:flex-row items-center justify-between gap-6">
      <Logo href="/" />
      <div className="text-sm text-center sm:text-right space-y-1">
        <p>Reuben's Reads · Rickmansworth, Hertfordshire · © {new Date().getFullYear()}</p>
        <p data-testid="footer-company-line" className="text-cream/70">
          Reuben's Reads is a trading name of {C.name}. Registered in England and Wales, company no. {C.number}.
        </p>
        <p className="space-x-4 pt-1">
          <a href="/terms" data-testid="footer-terms-link" className="underline underline-offset-4 hover:text-butter transition-colors">Terms & Conditions</a>
          <a href="/privacy" data-testid="footer-privacy-link" className="underline underline-offset-4 hover:text-butter transition-colors">Privacy Policy</a>
        </p>
      </div>
    </div>
  </footer>
);
